import React from 'react';

const TickVerified = (props: any) => {
  const { className } = props;
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      data-palette="TickVerified">
      <g fill="none" fillRule="evenodd">
        <g fill="var(--positive)" fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  d="M16 7.592l-1.811-2.006.283-2.686-2.648-.559L10.473 0 8 1.102 5.527 0l-1.35 2.341-2.65.56.284 2.685L0 7.592l1.811 2.005-.283 2.686 2.648.56 1.351 2.34L8 14.081l2.473 1.102 1.35-2.34 2.65-.56-.284-2.686L16 7.592zm-4.646-1.748l-4.016 4.488-2.79-2.783.663-.662L7.3 8.969l3.355-3.748.7.623z"
                  transform="translate(-249 -434) translate(220 328) translate(29 78) translate(0 28)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default TickVerified;
